export default "__VITE_ASSET__377d8beb__"